// basic react component
import React, { useState } from "react";
import Button from "./Button";

type Props = {
  onClick: () => void;
};

const NavBar: React.FC<Props> = ({ onClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  console.log(isOpen);

  return (
    <nav className="bg-white w-full mx-auto px-4 lg:px-8 pointer-events-auto z-10">
      <div className="flex justify-between h-16">
        <div className="flex">
          <a href="/" className="flex-shrink-0 flex items-center">
            <img src="logo.png" alt="Your Brand" className="h-12 w-12 mr-2" />
            <span className="font-bold text-xl text-gray-800">thieu.dev</span>
          </a>
        </div>
        <div className="flex items-center sm:hidden">
          <button
            type="button"
            className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            aria-controls="mobile-menu"
            aria-expanded={isOpen}
            onClick={() => setIsOpen((v) => !v)}
          >
            <span className="sr-only">Open main menu</span>
            {/* Icon: hamburger when closed, X when open */}
            {!isOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            )}
          </button>
        </div>
        <div className="hidden sm:flex items-center space-x-2">
          <Button
            variant="primary"
            label={"zkMaze"}
            onClick={() => window.open("https://thieu.dev/zkmaze", "_blank")}
          />
          <Button variant="primary" label={"Join our team"} onClick={onClick} />
        </div>
      </div>
      {/* Mobile menu, show/hide based on isOpen */}
      <div
        id="mobile-menu"
        className={`sm:hidden ${isOpen ? "block" : "hidden"}`}
      >
        <div className="flex flex-col pb-4 pt-2">
          <div className="mb-3">
            <Button
              variant="primary"
              fullWidth
              label={"zkMaze"}
              onClick={() => {
                window.open("https://thieu.dev/zkmaze", "_blank");
                setIsOpen(false);
              }}
            />
          </div>
          <div className="mb-3">
            <Button
              variant="primary"
              fullWidth
              label={"Join our team"}
              onClick={() => {
                onClick();
                setIsOpen(false);
              }}
            />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
